export const desktopNavLinks = [
  {
    id: 1,
    linkTo: '/search',
    icon: 'search',
    label: 'Search',
  },
  {
    id: 2,
    linkTo: '/',
    icon: 'home',
    label: 'Home',
  },
  {
    id: 3,
    linkTo: '/videos',
    icon: 'movie_creation',
    label: 'Videos',
  },
  {
    id: 4,
    linkTo: '/playlists',
    icon: 'queue',
    label: 'Playlists',
  },
  {
    id: 5,
    linkTo: '/liked',
    icon: 'thumb_up',
    label: 'Liked',
  },

  {
    id: 6,
    linkTo: '/history',
    icon: 'history',
    label: 'History',
  },
  {
    id: 7,
    linkTo: '/watchlater',
    icon: 'watch_later',
    label: 'Watch Later',
  },
  {
    id: 8,
    linkTo: '/profile',
    icon: 'person',
    label: 'Profile',
  },
];
